/**
 * Clase de utilidad para transformar los objetos que devuelve el api de inditex en los objetos que usaremos en el cms, widgets y render
 * */

import { ApiGetWishlistResponse, ApiPutWishlistResponse } from '../../domain/models/api-wishlist.models';
import { ApiWishlist } from '../../domain/models/wishlist.models';

// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class WishlistModelsTransformer {
    public static WishlistFromApi(apiWishlist: ApiGetWishlistResponse, name: string): ApiWishlist {
        // biome-ignore lint/complexity/noThisInStatic: <explanation>
        const wishlist = this.getWishlist(apiWishlist, name);
        if (wishlist) {
            return wishlist;
        }
        return null;
    }

    public static WishlistPutResponse(apiWishlist: ApiPutWishlistResponse, name: string): ApiWishlist {
        // biome-ignore lint/complexity/noThisInStatic: <explanation>
        return this.getWishlist(apiWishlist, name);
    }

    public static getWishlist(apiWishlist: ApiGetWishlistResponse | ApiPutWishlistResponse, name: string): ApiWishlist {
        if (apiWishlist?.wlArray?.length > 0) {
            const wishlist: ApiWishlist = { name };
            const wl = apiWishlist.wlArray.find((e) => e.name === name);
            if (wl) {
                wishlist.items = wl.items.filter(e => !!e).map((item) => {
                    const newItem = { ...item };
                    newItem.productId = Number(item.productId);
                    newItem.catentryId = Number(item.catentryId);
                    return newItem;
                });

                return wl;
            }
            return null;
        }
    }
}
